import * as React from "react";
export const ProjetoBottom = () => {
  return (
    <React.Fragment>
      <div></div>
    </React.Fragment>
  );
};
